import { render, staticRenderFns } from "./mktTableJoinVariationData.vue?vue&type=template&id=2a9b2cfc&"
import script from "./mktTableJoinVariationData.vue?vue&type=script&lang=js&"
export * from "./mktTableJoinVariationData.vue?vue&type=script&lang=js&"
import style0 from "./mktTableJoinVariationData.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports